
import { t } from "@/plugins/i18n";
// K2D "Riportok -> Paraméteres" (w_popup_report_param) modelljei — ad-hoc paraméteres
// lekérdezés a könyvelt tételsorok fölött.

export interface ParamReportFilter {
  accDateFrom: string | null;
  accDateTo: string | null;
  totalFrom: number | null;
  totalTo: number | null;
  // fksz/dimenzió: jokerrel ('*', '?') is megadható — akkor illesztés fut tartomány helyett
  accnoFrom: string;
  accnoTo: string;
  dim1From: string;
  dim1To: string;
  dim2From: string;
  dim2To: string;
  dim3From: string;
  dim3To: string;
  transIdFrom: number;
  transIdTo: number;
  insDateFrom: string | null;
  insDateTo: string | null;
  accEvent: string;
  note: string;
  // Rögzítő (hxboktrans.userid); 0 = nincs szűrés
  recorderId: number;
  withStorno: boolean;
  bookTypeIds: number[];
  prefixes: string[];
  orderBy: string;
}

export const DefaultParamReportFilter: ParamReportFilter = {
  accDateFrom: null,
  accDateTo: null,
  totalFrom: null,
  totalTo: null,
  accnoFrom: "",
  accnoTo: "",
  dim1From: "",
  dim1To: "",
  dim2From: "",
  dim2To: "",
  dim3From: "",
  dim3To: "",
  transIdFrom: 0,
  transIdTo: 0,
  insDateFrom: null,
  insDateTo: null,
  accEvent: "",
  note: "",
  recorderId: 0,
  withStorno: false,
  bookTypeIds: [],
  prefixes: [],
  orderBy: "accDate",
};

// K2D "Rendezettség" egyválasztós opciói (default: Dátum)
export const ParamReportOrderByOptions = [
  { id: "accDate", name: t("Datum") },
  { id: "total", name: t("Osszeg") },
  { id: "accno", name: t("FokSzam") },
  { id: "dim1", name: "I. dim" },
  { id: "dim2", name: "II. dim" },
  { id: "dim3", name: "III. dim" },
  { id: "trans", name: t("GeneralLedger_Tranzakcio") },
  { id: "accEvent", name: t("GazdEsemeny") },
  { id: "note", name: t("Megjegyzes") },
  { id: "insDate", name: t("GeneralLedger_LetrehDat") },
  { id: "recorder", name: t("Rogzito") },
];

export interface ParamReportRow {
  id: number;
  transId: number;
  accDate: string;
  debit: number;
  credit: number;
  note: string;
  bookTypeName: string;
  prefix: string;
  invNo: number;
  accEvent: string;
  statusName: string;
  remark: string;
  transTypeName: string;
  accno: string;
  dim1: string;
  dim2: string;
  dim3: string;
  insDate: string;
  recorderName: string;
  storno: string;
  transSt: number | null;
}

export interface ParamReportLookupItem {
  id: number;
  name: string;
}

export interface ParamReportPrefix {
  code: string;
}

// A "Tranzakció (-tól/-ig)" választó egy sora (K2D d_g_hxboktrans_query)
export interface ParamReportTransaction {
  id: number;
  accEvent: string;
}

export interface ParamReportLookups {
  bookTypes: ParamReportLookupItem[];
  prefixes: ParamReportPrefix[];
  recorders: ParamReportLookupItem[];
}

export interface ParamReportPageResult {
  currentPage: ParamReportRow[];
  totalCount: number;
}

export interface ParamReportPdfResult {
  success: boolean;
  message: string;
  pdf: string | null;
}
